import { AddressFields } from 'components/inputs/address/types'
import { REGISTRATION_FLOW } from 'features/registration/constants'
import { RegistrationSteps } from 'features/registration/types'
import { getStartDateRange } from 'features/registration/utils'
import { Language } from 'types/language'
import {
  BillingFieldKeys,
  CustomerFlows,
  DeliveryAddressFieldKeys,
  FlowAlternatives,
  InputGroupKeys,
  MeterDetailsFieldKeys,
  OverviewFieldKeys,
  PersonalDataFieldKeys,
  SimulationFieldKeys
} from './enums'
import { CustomerStore } from './types'
import { INITIAL_FOW } from 'features/simulation/Simulation.constants'
import { SimulationSteps } from 'features/simulation/types'
import {
  CONTACT_MODES,
  COUNTER_TYPES,
  EAN_CAPTURE_TYPES,
  ESTIMATED_USAGES,
  METER_TYPES,
  PAYMENT_METHODS,
  SIMULATION_TYPES,
  SITUATIONS,
  USAGE_GRADES
} from '@boltenergy-be/shared'

export const initialCustomerState: CustomerStore = {
  flows: {
    [CustomerFlows.REGISTRATION]: {
      currentStep: RegistrationSteps.DELIVERY_ADDRESS,
      steps: REGISTRATION_FLOW,
      creditCheckRequired: false
    },
    [CustomerFlows.SIMULATION]: {
      contactMe: undefined,
      currentStep: SimulationSteps.POSTAL_CODE,
      didSimulation: false,
      error: false,
      isLoading: false,
      steps: INITIAL_FOW,
      visible: false
    }
  },
  inputs: {
    [InputGroupKeys.SIMULATION]: {
      [SimulationFieldKeys.REGION]: null,
      [SimulationFieldKeys.METER_TYPE]: METER_TYPES.single,
      [SimulationFieldKeys.HAS_EXCLUSIVE_NIGHT_METER]: false,
      [SimulationFieldKeys.USAGE]: {
        electricity: {
          consumption: {
            single: ESTIMATED_USAGES[USAGE_GRADES.low].Residential.electricity.consumption
          }
        },
        solarKva: undefined,
        grade: USAGE_GRADES.low
      },
      [SimulationFieldKeys.PRICE_WITHOUT_PROMO]: null,
      [SimulationFieldKeys.FORCED_AMOUNT]: null,
      [SimulationFieldKeys.REFERRAL_CODE]: null,
      [SimulationFieldKeys.PROMO_CODE]: null,
      [SimulationFieldKeys.SOLAR_PANELS]: null,
      [SimulationFieldKeys.CHOSEN_SIMULATION_TYPE]: SIMULATION_TYPES.pricingSimulation
    },
    [InputGroupKeys.DELIVERY_ADDRESS]: {
      [DeliveryAddressFieldKeys.ADDRESS]: {
        [AddressFields.STREET_NAME]: '',
        [AddressFields.STREET_NUMBER]: '',
        [AddressFields.STREET_BOX]: '',
        [AddressFields.POSTAL_CODE]: '',
        [AddressFields.TOWN_NAME]: undefined,
        [AddressFields.TOWN_CODE]: 0,
        [AddressFields.COUNTRY_CODE]: 'BE'
      },
      [DeliveryAddressFieldKeys.NEEDS_GAS]: false
    },
    [InputGroupKeys.PERSONAL_DATA]: {
      [PersonalDataFieldKeys.IS_COMPANY]: false,
      [PersonalDataFieldKeys.FIRSTNAME]: '',
      [PersonalDataFieldKeys.LASTNAME]: '',
      [PersonalDataFieldKeys.EMAIL]: '',
      [PersonalDataFieldKeys.REPEAT_EMAIL]: '',
      [PersonalDataFieldKeys.MOBILE_PHONE]: '',
      [PersonalDataFieldKeys.DATE_OF_BIRTH]: undefined,
      [PersonalDataFieldKeys.LANGUAGE]: Language.DUTCH,
      [PersonalDataFieldKeys.CREDIT_CHECK]: {
        executed: false
      }
    },
    [InputGroupKeys.METER_DETAILS]: {
      [MeterDetailsFieldKeys.SITUATION]: SITUATIONS.switch,
      [MeterDetailsFieldKeys.UPLOAD]: null,
      [MeterDetailsFieldKeys.METER_READING_MONTH]: null,
      [MeterDetailsFieldKeys.CONTRACT_START_DATE]: getStartDateRange(SITUATIONS.switch).initial,
      [MeterDetailsFieldKeys.HAS_SOLAR_PANELS]: false,
      [MeterDetailsFieldKeys.COUNTER_TYPE]: COUNTER_TYPES.digital,
      [MeterDetailsFieldKeys.KNOWS_METER_DETAILS]: true,
      [MeterDetailsFieldKeys.ELECTRICITY]: {
        day: null,
        ean: null,
        eanExclNight: null,
        exclNight: null,
        meterNumber: null,
        night: null,
        total: null
      },
      [MeterDetailsFieldKeys.GAS]: {
        ean: null,
        meterNumber: null,
        total: null
      },
      [MeterDetailsFieldKeys.EAN_CAPTURE_TYPE]: EAN_CAPTURE_TYPES.noLookupDone
    },
    [InputGroupKeys.BILLING]: {
      [BillingFieldKeys.SAME_CORRESPONDENCE_ADDRESS]: true,
      [BillingFieldKeys.CORRESPONDENCE_ADDRESS]: {
        [AddressFields.STREET_NAME]: '',
        [AddressFields.STREET_NUMBER]: '',
        [AddressFields.STREET_BOX]: '',
        [AddressFields.POSTAL_CODE]: '',
        [AddressFields.TOWN_NAME]: '',
        [AddressFields.TOWN_CODE]: 0,
        [AddressFields.COUNTRY_CODE]: 'BE'
      },
      [BillingFieldKeys.PAYMENT_METHOD]: PAYMENT_METHODS.domiciliation,
      [BillingFieldKeys.DELIVERY_MODE]: CONTACT_MODES.email,
      [BillingFieldKeys.IBAN]: ''
    },
    [InputGroupKeys.OVERVIEW]: {
      [OverviewFieldKeys.SIGNATURE]: '',
      [OverviewFieldKeys.CHOSEN_SIGN_CHANNEL]: undefined
    }
  },
  isFetchingProducers: false,
  personalizedProducers: {
    [Language.DUTCH]: {},
    [Language.FRENCH]: {}
  },
  propositions: {
    simulatedPropositions: null
  },
  extraAddress: {
    isExtraAddressFlow: false
  },
  flowAlternative: {
    [FlowAlternatives.TELESALES_CAMPAIGN]: false,
    [FlowAlternatives.PLENTY]: false,
    [FlowAlternatives.ITSME]: false
  },
  itsme: {}
}
